import { createSelector } from 'reselect'
import { getCurrentMedia } from 'redux/currentMedia/selectors'

export const getBookmarked = state => state.bookmarks

export const isCurrentMediaBookmarked = createSelector(
    getBookmarked,
    getCurrentMedia,
    (bookmarks, currentMedia) => {
        if(! currentMedia.uuid)
        {
            return false
        }

        let currentMediaIsBookmarked = false
        bookmarks.forEach(bookmark => {
            if(
                bookmark.uuid === currentMedia.uuid
                && bookmark.arkId.arkName === currentMedia.record.arkId.arkName
            )
            {
                currentMediaIsBookmarked = true
            }
        })

        return currentMediaIsBookmarked
    },
)

export const bookmarkButtonTitle = createSelector(
    isCurrentMediaBookmarked,
    (bookmarked) => ! bookmarked ? 'visualizer:toolbar.left.bookmark.create.button' : 'visualizer:toolbar.left.bookmark.remove.button'
)
